export default __webpack_public_path__ + "static/media/image-40.4676554f.png";